import React, { Suspense, lazy } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { LayoutSplashScreen, ContentRoute } from '../_metronic/layout';
//import { BuilderPage } from "./pages/BuilderPage";
//import { MyPage } from "./pages/MyPage";
import { AuthPage } from './modules/Auth';
import { DashboardPage } from './pages/DashboardPage';
import OrdersPage from './modules/Purchase/pages/orders/OrdersPage';
import { OrderViewDialog } from './modules/Purchase/pages/orders/order-view-dialog/OrderViewDialog';
import BoxesPage from './modules/Purchase/pages/boxes/BoxesPage';
import { BoxViewDialog } from './modules/Purchase/pages/boxes/box-view-dialog/BoxViewDialog';
import ProductsPage from './modules/Products/pages/products/ProductsPage';
import { ProductViewDialog } from './modules/Products/pages/products/product-view-dialog/ProductViewDialog';
import StocksPage from './modules/Stocks/pages/stocks/StocksPage';
import { StockCreateDialog } from './modules/Stocks/pages/stocks/stock-create-dialog/StockCreateDialog';
import { StockViewDialog } from './modules/Stocks/pages/stocks/stock-view-dialog/StockViewDialog';
import User from './modules/MerchantUser/pages/UsersPage';
//import UserProfilePage from "./modules/UserProfile/UserProfilePage";
import ResetPassword from './modules/Auth/pages/ResetPassword';
import { UserEditDialog } from './modules/MerchantUser/pages/user-edit-dialog/UserEditDialog';
import SalesPage from './modules/Sales/pages/SalesPage';
import { SaleViewDialog } from './modules/Sales/pages/sale-view-dialog/SaleViewDialog';
import DeliveriesPage from './modules/Deliver/pages/DeliveriesPage';
import { DeliverViewDialog } from './modules/Deliver/pages/deliver-view-dialog/DeliverViewDialog';
import { FinanceSalesPage } from './modules/Finance/Sales/FinanceSalesPage';
import { FinancePurchasePage } from './modules/Finance/Purchase/FinancePurchasePage';
import { FinanceStocksPage } from './modules/Finance/Stocks/FinanceStocksPage';

const UserProfilepage = lazy(() =>
  import('./modules/UserProfile/UserProfilePage')
);

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from='/' to='/dashboard' />
        }
        <ContentRoute path='/dashboard' component={DashboardPage} />
        <ContentRoute path='/orders/new/' component={OrderViewDialog} />
        <ContentRoute path='/orders/:id/edit' component={OrderViewDialog} />
        <ContentRoute path='/orders' component={OrdersPage} />
        <ContentRoute path='/boxes/:id/edit' component={BoxViewDialog} />
        <ContentRoute path='/boxes' component={BoxesPage} />
        <ContentRoute path='/products/new/' component={ProductViewDialog} />
        <ContentRoute path='/products/:id/edit' component={ProductViewDialog} />
        <ContentRoute path='/products' component={ProductsPage} />
        <ContentRoute path='/stocks/new/' component={StockCreateDialog} />
        <ContentRoute path='/stocks/:id/edit' component={StockViewDialog} />
        <ContentRoute path='/stocks' component={StocksPage} />
        <ContentRoute path='/sales/new' component={SaleViewDialog} />
        <ContentRoute path='/sales/:id/edit' component={SaleViewDialog} />
        <ContentRoute path='/sales' component={SalesPage} />
        <ContentRoute path='/deliveries/new' component={DeliverViewDialog} />
        <ContentRoute
          path='/deliveries/:id/edit'
          component={DeliverViewDialog}
        />
        <ContentRoute path='/deliveries' component={DeliveriesPage} />
        <ContentRoute path='/financeSales' component={FinanceSalesPage} />
        <ContentRoute path='/financeOrders' component={FinancePurchasePage} />
        <ContentRoute path='/financeStocks' component={FinanceStocksPage} />

        <ContentRoute path='/users/new' component={UserEditDialog} />
        <ContentRoute path='/users/:id/edit' component={UserEditDialog} />
        <ContentRoute path='/users' component={User} />
        <Route path='/auth/reset-password/:token' component={ResetPassword} />
        <Route path='/user-profile' component={UserProfilepage} />
        <Redirect to='error/error-v3' />
      </Switch>
    </Suspense>
  );
}
